<template>
  <footer class="site-footer">
    <div class="com-size container">
      <div class="col-left">
        <ul class="link-ul">
          <li v-for="(item, index) in linkList" :key="index" @click="() => $router.push(item.path)">
            <span class="link-title">{{ item.title }}</span>
            <span v-if="index !== linkList.length - 1">|</span>
          </li>
        </ul>
        <div>
          版权所有 Copyright(C)2014-2015 
          <span>
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=34011102003710" rel="noreferrer" target="_blank">皖ICP备2025081292号-2</a>
          </span>
          <span>
            <img src="@/assets/images/home/ga.png" />皖公网安备: 34011102003710号
          </span>
          
        </div>
        <div>
          地址：合肥市滨湖新区华山路808号徽盐世纪广场A座
          <span>电话：0551-62855965</span>
        </div>
        <div class="share">
          分享到：
          <span>
            <a
              href="http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url={}&amp;title={}&amp;desc={}&amp;summary={}&amp;site={}&amp;pics={}"
              target="_blank"
              class="qq"
            >
              <img
                src="@/assets/images/home/qq.png"
                alt=""
                width="auto"
                height="18px"
              />
            </a>
          </span>
          <span>
            <a
              title="分享到微信"
              class="bshare-weixin wx"
              href="javascript:void(0);"
            >
              <img
                src="@/assets/images/home/wexin.png"
                alt=""
                width="auto"
                height="20px"
              />
            </a>
          </span>
        </div>
      </div>
      <div class="col-right">
        <div>
          <img src="../assets/images/home/wecode.jpg" alt="" />
          <div>官方微信</div>
        </div>
        <!-- <div>
          <img src="../assets/images/home/wecode.jpg" alt="" />
          <div>官方微信</div>
        </div> -->
      </div>
    </div>
    
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      email: '',
      showBackToTop: false,
      linkList: [
        // {
        //   title: '公司概述',
        //   path: '/overview?index=0',
        // },
        // {
        //   title: '组织架构',
        //   path: '/overview?index=1',
        // },
        // {
        //   title: '企业文化',
        //   path: '/overview?index=2',
        // },
        // {
        //   title: '公司愿景',
        //   path: '/overview?index=3',
        // },
        {
          title: '安徽省人力资源有限公司',
          path: '/overview?id=6da15a9cc0764bf7a4c78c1894bdf2d6',
        },
        {
          title: '安徽国资国企研究院有限公司',
          path: '/overview?id=61eb9414a5b44173b2555d397a9abad8',
        },
      ],
      footerNavs: [
        {
          title: '产品服务',
          links: [
            { text: '产品一', url: '/products/product-1', internal: true },
            { text: '产品二', url: '/products/product-2', internal: true },
            { text: '产品三', url: '/products/product-3', internal: true },
            { text: '解决方案', url: '/solutions', internal: true },
            { text: '服务支持', url: '/support', internal: true },
          ],
        },
        {
          title: '关于我们',
          links: [
            { text: '公司介绍', url: '/about', internal: true },
            { text: '发展历程', url: '/about/history', internal: true },
            { text: '企业文化', url: '/about/culture', internal: true },
            { text: '加入我们', url: '/careers', internal: true },
            { text: '联系方式', url: '/contact', internal: true },
          ],
        },
        {
          title: '资源中心',
          links: [
            { text: '技术文档', url: '/docs', internal: true },
            { text: '视频教程', url: '/tutorials', internal: true },
            { text: '博客文章', url: '/blog', internal: true },
            { text: '常见问题', url: '/faq', internal: true },
            { text: '下载中心', url: '/downloads', internal: true },
          ],
        },
      ],
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    submitNewsletter() {
      // 处理订阅逻辑
      alert(`感谢订阅！邮箱: ${this.email}`)
      this.email = ''

      // 实际项目中应该调用API提交表单数据
      // this.$http.post('/api/subscribe', { email: this.email })
      //   .then(response => {
      //     // 处理成功响应
      //   })
      //   .catch(error => {
      //     // 处理错误
      //   });
    },
    handleScroll() {
      // 当页面滚动超过300px时，显示返回顶部按钮
      this.showBackToTop = window.scrollY > 300
    },
    
  },
}
</script>

<style lang="scss" scoped>
.site-footer {
  position: relative;
  background-color: #333;
  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #8d8d8d;
    font-size: 14px;
    padding: 26px 10px;
  }
  .col-left {
    > div {
      margin-top: 8px;
      span {
        margin-left: 13px;
        a {
          color: #8d8d8d;
          &:hover {
            color: #fff;
          }
          //vertical-align: middle;
        }
        img {
          vertical-align: bottom;
          margin-right: 5px;
        }
      }
    }
    .share {
      display: flex;
      align-items: center;
      img {
        // width: 18px;
        // height: auto;
      }
    }
  }
  .link-ul {
    display: flex;
    padding-bottom: 5px;
    li {
      padding-right: 24px;
      .link-title {
        color: #fff;
        cursor: pointer;
        margin-right: 24px;
      }
    }
  }
  .col-right {
    display: flex;
    > div {
      text-align: center;
      margin-left: 20px;
    }
    img {
      width: 78px;
      height: 78px;
      margin-bottom: 8px;
    }
  }

  // 主要内容区域
  .footer-main {
    padding: 70px 0 40px;

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
    }

    .footer-top {
      display: grid;
      grid-template-columns: 1fr 2fr 1fr;
      gap: 40px;

      @media (max-width: 992px) {
        grid-template-columns: 1fr 1fr;
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }
    }
  }

  // 公司信息区域
  .footer-company {
    .footer-logo {
      margin-bottom: 20px;

      img {
        max-height: 40px;
      }
    }

    .company-desc {
      margin-bottom: 20px;
      line-height: 1.7;
    }

    .social-links {
      display: flex;
      gap: 15px;

      .social-link {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
        color: white;
        transition: all 0.3s ease;

        &:hover {
          background-color: #3f80ea;
          transform: translateY(-3px);
        }

        i {
          font-size: 16px;
        }
      }
    }
  }

  // 导航链接区域
  .footer-nav-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;

    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
      grid-template-columns: 1fr;
    }
  }

  .footer-nav {
    .footer-nav-title {
      color: white;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 20px;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 0;
        width: 30px;
        height: 2px;
        background-color: #3f80ea;
      }
    }

    .footer-nav-links {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 10px;

        a {
          color: #a5b1c2;
          text-decoration: none;
          transition: color 0.3s ease;
          position: relative;

          &:hover {
            color: white;
            padding-left: 5px;
          }

          &:before {
            content: '›';
            margin-right: 8px;
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          &:hover:before {
            opacity: 1;
          }
        }
      }
    }
  }

  // 联系与订阅区域
  .footer-contact {
    .contact-info {
      margin-bottom: 30px;

      p {
        margin-bottom: 10px;
        display: flex;
        align-items: flex-start;

        i {
          margin-right: 10px;
          margin-top: 3px;
        }
      }
    }

    .newsletter {
      .newsletter-form {
        display: flex;
        margin-top: 15px;

        input {
          flex: 1;
          padding: 12px 15px;
          background-color: rgba(255, 255, 255, 0.1);
          border: none;
          border-radius: 4px 0 0 4px;
          color: white;
          outline: none;

          &::placeholder {
            color: #a5b1c2;
          }

          &:focus {
            background-color: rgba(255, 255, 255, 0.15);
          }
        }

        button {
          padding: 12px 20px;
          background-color: #3f80ea;
          color: white;
          border: none;
          border-radius: 0 4px 4px 0;
          cursor: pointer;
          transition: background-color 0.3s ease;

          &:hover {
            // background-color: darken(#3f80ea, 10%);
          }
        }
      }
    }
  }

  // 底部版权区域
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 20px 0;

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
        gap: 15px;
      }
    }

    .copyright {
      p {
        margin: 0;
      }
    }

    .legal-links {
      display: flex;
      gap: 20px;

      @media (max-width: 576px) {
        flex-wrap: wrap;
        justify-content: center;
        gap: 15px;
      }

      a {
        color: #a5b1c2;
        text-decoration: none;
        transition: color 0.3s ease;
        font-size: 13px;

        &:hover {
          color: white;
        }
      }
    }
  }

  // 返回顶部按钮
  .back-to-top {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 45px;
    height: 45px;
    background-color: #3f80ea;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 99;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

    &:hover {
      // background-color: darken(#3f80ea, 10%);
      transform: translateY(-5px);
    }

    i {
      font-size: 20px;
    }
  }
}
</style>
